import { Currency, Language } from 'src/types/graphql'

export const CURRENCIES = Object.values(Currency).map((c) => c.toUpperCase())

type ILanguageConfig = {
  value: string
  langNameEn: string
  langNameEs: string
  locale: Language
  abbr: string
}

export const LANGUAGES_MAP: { [key in Language]: ILanguageConfig } = {
  [Language.En]: {
    value: 'NAV_LANGUAGE_DROPDOWN.ENGLISH',
    langNameEn: 'English',
    langNameEs: 'Inglés',
    locale: Language.En,
    abbr: 'ENG'
  },
  [Language.Es]: {
    value: 'NAV_LANGUAGE_DROPDOWN.SPANISH',
    langNameEn: 'Spanish',
    langNameEs: 'Español',
    locale: Language.Es,
    abbr: 'ESP'
  }
}
